module.exports = __webpack_public_path__ + "img/story041@2x.f2cbf510.webp";